import { generateUUID } from '@/common/utils/commonUtils';
import {
  AvgMetricsAggregations,
  CountMetricsAggregations,
  MaxMetricsAggregations,
  MetricsAggregation,
  MetricsAggregationsType,
  MinMetricsAggregations,
  PercentilesMetricsAggregations,
  RateMetricsAggregations,
  StatsMetricsAggregations,
  SumMetricsAggregations,
  TopMetricsMetricsAggregations,
} from './MetricsAggregation';

export class MetricsAggregationFactory {
  static createMetricsAggregation(
    type: MetricsAggregationsType,
    show: boolean = true,
  ): MetricsAggregation {
    switch (type) {
      case 'count':
        return new CountMetricsAggregations(generateUUID(), show);
      case 'avg':
        return new AvgMetricsAggregations(generateUUID(), show);
      case 'max':
        return new MaxMetricsAggregations(generateUUID(), show);
      case 'min':
        return new MinMetricsAggregations(generateUUID(), show);
      case 'sum':
        return new SumMetricsAggregations(generateUUID(), show);
      case 'percentiles':
        return new PercentilesMetricsAggregations(generateUUID(), show);
      case 'rate':
        return new RateMetricsAggregations(generateUUID(), show);
      case 'stats':
        return new StatsMetricsAggregations(generateUUID(), show);
      case 'topMetrics':
        return new TopMetricsMetricsAggregations(generateUUID(), show);
      default:
        throw new Error(`Unknown metrics aggregation type: ${type}`);
    }
  }
}
